module.exports = __webpack_public_path__ + "static/media/guide_des_demarches_obseques.8b38a63e.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/data/products/go/documents/common/guide_des_demarches_obseques.pdf
// module id = 308
// module chunks = 40